import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth/withWidth';
import Button from '@material-ui/core/Button/Button';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography/Typography';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import clsx from 'clsx';
import { CloseMenuIcon, ChevronLeftIcon } from '../../../Icons';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      pointerEvents: 'none',
      background: 'none',
      marginTop: theme.layout.appbar.heightSm,
      '& .MuiBackdrop-root': {
        display: 'none',
      },
      '& .MuiDialog-paperFullScreen': {
        boxShadow: 'none',
      },
      // the available width (see container) is reduced by the width of the two arrows
      //  width: `calc(100% - ${theme.spacing(4)}px)`,
      [theme.breakpoints.up('sm')]: {
      },
      [theme.breakpoints.up('xl')]: {
      },

    },
    rootWithDesignArea: {
      marginTop: theme.layout.appbar.heightSm + 220,
    },
    headerDialog: {
      '& .MuiBackdrop-root': {
        display: 'none',
      },
      '& .MuiDialog-paperFullScreen': {
        boxShadow: 'none',
      },
      pointerEvents: 'none',
      background: 'none',
      minHeight: theme.layout.appbar.heightSm,
      maxHeight: theme.layout.appbar.heightSm,
    },
    allowPointerEvents: {
      pointerEvents: 'all',
    },
    toolbarHeaderWrapper: {
      pointerEvents: 'all',
      zIndex: 11,
      minHeight: theme.layout.appbar.heightSm,
      maxHeight: theme.layout.appbar.heightSm,
      padding: theme.spacing(0, 3),
    },
    closeButton: {
      height: 48,
      paddingTop: 2,
      borderRadius: 100,
      //   textTransform: 'lowercase',
      marginLeft: 'auto',
      padding: 0,
      '&:hover, &:active, &:focus': {
        background: 'transparent',
      },
      '& .MuiButton-label': {
        marginRight: -8,
        marginLeft: 'auto',
        width: 36,
        height: 36,
        borderRadius: 100,
        '&:hover': {
          background: '#959595',
          [theme.breakpoints.up('sm')]: {
            background: 'transparent',
          },
        },
        ' &:active, &:focus': {
          background: '#585858',
          [theme.breakpoints.up('sm')]: {
            background: 'transparent',
          },
        },

        [theme.breakpoints.up('sm')]: {
          width: 'auto',
          marginRight: 0,
          marginLeft: 0,
          height: 1,
        },
        [theme.breakpoints.up('xl')]: {
          minHeight: 1,
        },
        '& > span': {
          marginLeft: theme.layout.buttonIcon.paddingLeft + 4,
          display: 'none',
          [theme.breakpoints.up('sm')]: {
            display: 'inherit',
          },
        },
      },
      '& .MuiSvgIcon-root': {
        minWidth: '24px !important',
        height: theme.layout.appbar.heightSm - theme.spacing(4),
        width: 'auto',
        padding: theme.spacing(2, 0),
        [theme.breakpoints.up('sm')]: {
          marginLeft: theme.layout.buttonIcon.paddingLeft,
          marginRight: -5.5,
          height: theme.layout.appbar.height - theme.spacing(6),
        },
        [theme.breakpoints.up('xl')]: {
          minHeight: theme.layout.appbar.height - theme.spacing(6),
        },
      },
    },
    backButton: {
      borderRadius: 100,
      height: 36,
      width: 36,
      marginLeft: -12,
      '&:hover': {
        background: '#959595',
      },
      '&:focus, &:active': {
        background: '#585858',
      },
      margin: 0,
      marginRight: 9,
      minWidth: '24px !important',
      padding: 0,
      '& .MuiSvgIcon-root': {
        height: theme.layout.appbar.heightSm - theme.spacing(4),
        width: 'auto',
        padding: theme.spacing(2, 0),
        [theme.breakpoints.up('sm')]: {
          height: theme.layout.appbar.height,
        },
        [theme.breakpoints.up('xl')]: {
          minHeight: theme.layout.appbar.heightXL,
        },
      },
    },
    dialogAction: {
      padding: 0,
      '& .MuiButton-root, .MuiButton-contained:hover.Mui-disabled': {
        height: theme.layout.appbar.heightSm,
        pointerEvents: 'all',
        boxShadow: 'none',
        textTransform: 'unset',
        ...theme.typography.button.fontSize,
        margin: 0,
        background: theme.palette.configBtn.dark,
        color: theme.palette.configBtn.darkText,
        borderRadius: 0,
        position: 'fixed',
        bottom: 0,
        '&:hover': {
          background: '#959595',
        },
        '&:focus,&:active': {
          background: '#585858',
        },
      },
    },
    marginBottomAppbarHeight: {
      '& > *': {

        marginBottom: theme.layout.appbar.heightSm,
      },
    },
    dialogActionButton: {

    },
    headingContent: {
      display: 'flex',
    },
    bottomBtn: {
      '&.Mui-disabled': {
        background: '#EFEFEF',
        color: '#A3A3A3',
        border: '1px solid #A3A3A3',
        zIndex: 10000000000,
        '&:hover,&:active,&:focus': {
          opacity: 1,
          background: '#EFEFEF',
          color: '#A3A3A3',
          border: '1px solid #A3A3A3',
        },
      },
      fontWeight: 'bold',
      textTransform: 'lowercase',
    },
  }),
  { name: 'MobilePickerMenuStep' },
);

const MobilePickerMenuStep = ({
  width,
  doDisplay,
  renderStep,
  heading, backFunc, closeFunc, renderActionButtonProps, doDisplayDesignArea,
}) => {
  useEffect(() => {

  }, []);
  const classes = useStyles();

  const renderCloseBtn = () => (
    <Button className={classes.closeButton} onClick={closeFunc} color="inherit">
      <CloseMenuIcon />
    </Button>
  );

  const renderBackBtn = () => (
    <Button className={classes.backButton} onClick={backFunc} color="inherit">
      <ChevronLeftIcon />
    </Button>
  );
  const renderHeading = () => (
    <>
      {backFunc && renderBackBtn()}
      <Typography variant="h2" color="inherit">
        {heading}
      </Typography>
      {closeFunc && renderCloseBtn()}
    </>
  );
  return (
    <>
      {doDisplay && !isWidthUp('sm', width)
      && (
        <>
          <Dialog
            transitionDuration={0}
            open={doDisplay}
            fullScreen
            onClose={backFunc}
            className={clsx(classes.headerDialog)}
            disableBackdropClick
          >
            {' '}
            <Toolbar classes={{ regular: classes.toolbarHeaderWrapper }}>
              {renderHeading()}
            </Toolbar>

          </Dialog>
          <Dialog
            transitionDuration={0}
            open={doDisplay}
            fullScreen
            onClose={backFunc}
            className={clsx(classes.root, doDisplayDesignArea ? null : classes.allowPointerEvents, doDisplayDesignArea ? classes.rootWithDesignArea : null)}
            disableBackdropClick
          >

            <div className={clsx(classes.allowPointerEvents, renderActionButtonProps ? classes.marginBottomAppbarHeight : null)}>
              {renderStep()}
            </div>
            {!!renderActionButtonProps
        && (
        <DialogActions className={classes.dialogAction}>
          {
          (() => {
            const { title, ...rest } = renderActionButtonProps;
            return (
              <Button
                variant="contained"
                size="medium"
                fullWidth
                className={classes.bottomBtn}
                {...rest}
              >
                {title}
              </Button>
            );
          })()
          }

        </DialogActions>
        )}
          </Dialog>
        </>
      )}
    </>
  );
};

MobilePickerMenuStep.defaultProps = {
  doDisplay: false,
  renderStep: () => {},
  heading: '',
  backFunc: null,
  closeFunc: null,
  renderActionButtonProps: null,
  doDisplayDesignArea: false,
};

MobilePickerMenuStep.propTypes = {
  width: PropTypes.string,
  doDisplay: PropTypes.bool,
  renderStep: PropTypes.func,
  heading: PropTypes.string,
  backFunc: PropTypes.func,
  closeFunc: PropTypes.func,
  renderActionButtonProps: PropTypes.object,
  doDisplayDesignArea: PropTypes.bool,
};

export default withWidth({ initialWidth: 'lg' })(MobilePickerMenuStep);
